import styled, { css } from 'styled-components';
import { BaSeTheme } from '@base/react';

export const StyledJumbotron = styled.div`
  ${({ backgroundColor }) => css`
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
    background-color: ${backgroundColor};
    padding: 32px 0;
  `};
`;

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;
